var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 64,
    fill: "#EF3B58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214 57C217.314 57 219.966 59.6596 219.733 62.9651C218.659 78.2038 213.27 119.554 186.211 150.653C166.213 173.637 148.683 185.694 135.795 192.02C123.896 197.859 113 188.255 113 175L113 81C113 67.7452 123.745 57 137 57L214 57Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 200C39.6863 200 37.0407 197.322 37.3475 194.023C38.3534 183.206 42.2707 159.848 57.5263 141.961C74.5484 122.003 88.6267 115.34 96.13 113.115C99.307 112.173 102 114.686 102 118L102 176C102 189.255 91.2548 200 78 200L43 200Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ba34cf12e3204a65043b44b433a29dc.svg";
export { ForwardRef as ReactComponent };